
import { PropType, defineComponent } from 'vue'

type SimpleLinkListItems = {
  link: string
  heading: string
  label?: string
  current?: boolean
}[]

export default defineComponent({
  name: 'SimpleLinkList',

  props: {
    items: Array as PropType<SimpleLinkListItems>,
    series: {
      type: Boolean,
      default: false
    }
  }
})
